import { makeStyles } from '@material-ui/core/styles';

export const useStyles = makeStyles(theme => ({
    rolesListBody: {
        paddingBottom: '4rem',
        minHeight: '50vh',
        position: 'relative',
    },
}));
